import router from '@/router'
import { commit } from '@/utils/store'
import Api from '@/utils/api'

function parseJWT(accessToken) {
  return JSON.parse(atob(accessToken.split('.')[1]))
}

function checkExpired(getters) {
  const jwt = getters.jwt
  if (jwt) {
    const exp = jwt.exp
    const now = Math.trunc(Date.now() / 1000)
    const delta = exp - now

    // on compte 3 minutes de répit
    return delta < 180
  }
  return true
}

const storage = window.sessionStorage

function loadItem(key) {
  const item = storage.getItem(key)
  try {
    return JSON.parse(item)
  } catch (e) {
    storage.removeItem(key)
  }
}

function storeItem(key, value) {
  if (value && Object.keys(value).length > 0) {
    storage.setItem(key, JSON.stringify(value))
  } else {
    storage.removeItem(key)
  }
}

/**
 * Creation de la hierarchy de role
 */
function grantedAuthorities(authorities, hierarchy) {
  if (authorities && hierarchy) {
    const set = {}
    var lookup = Array.from(authorities)
    while (lookup.length) {
      const current = lookup.pop()
      if (!set[current]) {
        set[current] = true

        const implied = hierarchy
          .filter((i) => i.role === current)
          .map((i) => i.implies)
        if (implied.length) {
          lookup = lookup.concat(implied)
        }
      }
    }
    return Object.keys(set)
  }

  return authorities
}

// window.sessionStorage
export default {
  namespaced: true,
  state: {
    oauth: loadItem('oauth'),
    redirectAfterLogin: {},
    user: loadItem('user'),
    hierarchy: [
      {
        role: 'ROLE_PARAM_MEDISUIV',
        implies: 'ROLE_ADMIN',
      },
      {
        role: 'ROLE_ADMIN',
        implies: 'ROLE_OPERATOR',
      },
      {
        role: 'ROLE_OPERATOR',
        implies: 'ROLE_OPERATOR',
      },
    ],
    canShowListeCorrespondant: loadItem('canShowListeCorrespondant'),
  },

  getters: {
    confirmauth: (state) =>
      state.confirmauthentification != null &&
      state.confirmauthentification.enCours,
    logged: (state) => state.oauth != null,
    access_token: (state) =>
      state.oauth != null ? state.oauth.access_token : null,
    refresh_token: (state) =>
      state.oauth != null ? state.oauth.refresh_token : null,
    jwt: (state, getters) =>
      getters.access_token ? parseJWT(getters.access_token) : null,
    authorities: (state, getters) =>
      getters.jwt ? getters.jwt.authorities : null,
    grantedAuthorities: (state, getters) =>
      grantedAuthorities(getters.authorities, state.hierarchy),
    username: (state) => (state.user ? state.user.name : null),
    userid: (state) => (state.user ? state.user.id : null),
    tel: (state) => (state.oauth ? state.oauth.tel : null),
    nomComplet: (state) => (state.user ? state.user.nomComplet : null),
    // idTechnique: state => (state.user ? state.user.idTechnique : null),
    userActif: (state) => (state.user ? state.user.actif : false),
    userSalarie: (state) => (state.user ? state.user.salarie : false),
    dmcAccepte: (state) => (state.user ? state.user.dmcAccepte : false),
    correspondantEtablissement: (state) =>
      state.user ? state.user.correspondantEtablissement : false,
    correspondantEntreprise: (state) =>
      state.user ? state.user.correspondantEntreprise : false,
    correspondantGroupement: (state) =>
      state.user ? state.user.correspondantGroupement : false,
    expired: (state, getters) => () => {
      return checkExpired(getters)
    },
    canShowListeCorrespondant: (state) => state.canShowListeCorrespondant,
  },

  mutations: {
    /**
     * Mise en place d'un token oauth
     */
    token(state, oauth) {
      state.oauth = oauth
      storeItem('oauth', oauth)
    },

    /**
     * Mise en place du user
     */
    user(state, user) {
      state.user = user
      storeItem('user', user)

      if (user == null) {
        state.redirectAfterLogin = {
          name: 'Home',
          params: {
            sidebar: true,
          },
        }
        if (router.currentRoute.name !== 'Login') {
          router.push({
            name: 'Login',
          })
        }
      } else if (user.role == 'PARTICIPANT') {
        router.push({
          name: 'user/confirm',
          params: {
            sidebar: false,
          },
        })
      } else {
        // gestion de la navigation
        commit('confirmauthentification/enCours', true)
        router.push({
          name: 'Home',
          params: {
            sidebar: true,
          },
        })
      }
    },

    canShowListeCorrespondant(state) {
      new Api('user/canShowListeCorrespondant').get().then((response) => {
        state.canShowListeCorrespondant = response.body
        storeItem('canShowListeCorrespondant', state.canShowListeCorrespondant)
      })
    },

    /**
     * Refresh du user en place en évitant la validation sms
     */
    userRefresh(state, user) {
      state.user = user
      storeItem('user', user)
    },
  },

  actions: {
    /**
     * Permet de renvoyer vers la page de login et de conserver la destination après le login
     */
    loginAndRedirect({ state }, to) {
      // TODO gestion du path ou autre...
      state.redirectAfterLogin = {
        name: to.name,
        params: to.params,
      }

      router.push({
        name: 'Login',
      })
    },

    userAndCheckPermission({ commit }, payload) {
      commit('user', payload)
      commit('canShowListeCorrespondant')
    },
  },
}
